const currentArtwork = (state = {}, action) => {
    switch (action.type) {
        case 'SET_BOTH_ARTWORK':
            return {
                ...state,
                leftArtwork: action.payload,
                rightArtwork: action.payload
            };
        case 'SET_LEFT_ARTWORK':
            return {
                ...state,
                leftArtwork: action.payload
            };
        case 'SET_RIGHT_ARTWORK':
            return {
                ...state,
                rightArtwork: action.payload
            };
        case 'SET_URL_TO_ARTWORK':
            if (action.payload['both']) {
                return {
                    ...state,
                    leftArtwork: {
                        ...state.leftArtwork,
                        leftImage: action.payload.both
                    },
                    rightArtwork: {
                        ...state.rightArtwork,
                        rightImage: action.payload.both
                    }
                };
            } else {
                return {
                    ...state,
                    leftArtwork: {
                        ...state.leftArtwork,
                        leftImage: action.payload['left_artwork']
                            ? action.payload['left_artwork']
                            : state.leftArtwork.leftImage
                    },
                    rightArtwork: {
                        ...state.rightArtwork,
                        rightImage: action.payload['right_artwork']
                            ? action.payload['right_artwork']
                            : state.rightArtwork.rightImage
                    }
                };
            }
        default:
            return state;
    }
};

export default currentArtwork;
